// extracted by mini-css-extract-plugin
export default {"accordionContainer":"AccordionPanel-module__accordionContainer___1gwZh","clubbedAccordionContainer":"AccordionPanel-module__clubbedAccordionContainer___A8Yfm"};